var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMic = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 31.94 31.94"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 19405",
  transform: "translate(-324.036 -655.671)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 15.97,
  cy: 15.97,
  r: 15.97,
  "data-name": "Ellipse 1407",
  transform: "translate(324.036 655.671)"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 1.369,
  "data-name": "Group 12083"
}, /*#__PURE__*/React.createElement("path", {
  d: "M334.531 672.362a6.28 6.28 0 0 0 1.56 4.287 5.08 5.08 0 0 0 7.831 0 6.28 6.28 0 0 0 1.559-4.287",
  "data-name": "Path 6043"
}), /*#__PURE__*/React.createElement("path", {
  d: "M337.43 672.078v-8.009a3 3 0 0 1 .18-1.088 2.9 2.9 0 0 1 .553-.93 2.7 2.7 0 0 1 .842-.632 2.5 2.5 0 0 1 1-.237 2.55 2.55 0 0 1 1.843.869 2.95 2.95 0 0 1 .733 2.018V672a2.96 2.96 0 0 1-.734 2.017 2.39 2.39 0 0 1-3.685 0 2.96 2.96 0 0 1-.732-2.017",
  "data-name": "Path 6044"
}), /*#__PURE__*/React.createElement("path", {
  d: "M336.142 682.1h7.729",
  "data-name": "Line 681"
}), /*#__PURE__*/React.createElement("path", {
  d: "M340.006 682.099v-3.606",
  "data-name": "Line 682"
}), /*#__PURE__*/React.createElement("path", {
  d: "M345.481 669.477v2.885",
  "data-name": "Line 683"
}), /*#__PURE__*/React.createElement("path", {
  d: "M334.531 669.477v2.885",
  "data-name": "Line 684"
})))));
export { SvgMic as ReactComponent };
export default __webpack_public_path__ + "static/media/mic.a5b18d67cb9aafdb7bae0fbd04aca620.svg";